import React, {useMemo} from 'react'
import {useUIGameEndContext} from '../../../../../contexts/UIGameEndContext'
import {StatsTable} from '../../StatsTable'
import {ACTIVITY_IMAGE_PATH, ACTIVITY_TRANSLATION} from '../../../constants'

export const ActivityStats = () => {
    const {gameEndData, playersByRank} = useUIGameEndContext()
    const players = useMemo(() => playersByRank.flatMap((player) => player.color), [playersByRank])

    const headers = useMemo(() => Object.keys(ACTIVITY_IMAGE_PATH).map((key) => ({
        imagePath: ACTIVITY_IMAGE_PATH[key],
        tooltip: ACTIVITY_TRANSLATION[key].title,
    })), [])

    const rows = useMemo(() => players.map((player) => {
        const row: number[] = []
        const data = gameEndData.endGameState.activityStats[player]
        if(data === undefined) return [0, 0, 0, 0, 0, 0]
        row.push(data.proposedTrades)
        row.push(data.successfulTrades)
        row.push(data.resourcesUsed)
        row.push(data.resourceIncomeBlocked)
        row.push(data.devCardsBought)
        row.push(data.devCardsUsed)
        return row
    }), [players])

    return <>
        <StatsTable headers={headers} rows={rows}/>
    </>
}
